
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"xmlns":"http://www.w3.org/2000/svg","viewBox":"0 0 13 12","fill":"none"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{attrs:{"d":"M12.639 7.707v3.626c0 .374-.307.667-.698.667H1.336c-.39 0-.697-.293-.697-.667V7.707c0-.374.307-.667.697-.667.391 0 .698.293.698.667v2.96h9.21v-2.96c0-.374.306-.667.697-.667.39 0 .698.293.698.667zm-6.503.826c.126.134.307.2.503.2a.701.701 0 00.502-.2l2.777-2.72a.651.651 0 00-.014-.946.727.727 0 00-.99.013L7.335 6.44V.667C7.336.293 7.03 0 6.64 0c-.391 0-.698.293-.698.667V6.44l-1.59-1.547a.727.727 0 00-.991-.013.651.651 0 00-.014.947l2.79 2.706z","fill":"currentColor"}})])
          )
        }
      }
    